var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classNames from 'classnames';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import CloseCircleFilled from '@ant-design/icons/CloseCircleFilled';
import RCPicker from 'rc-picker';
import enUS from '../locale/en_US';
import { getPlaceholder } from '../util';
import { ConfigContext } from '../../config-provider';
import LocaleReceiver from '../../locale-provider/LocaleReceiver';
import SizeContext from '../../config-provider/SizeContext';
import { getTimeProps, Components, } from '.';
export default function generatePicker(generateConfig) {
    function getPicker(picker, displayName) {
        let Picker = /** @class */ (() => {
            class Picker extends React.Component {
                constructor() {
                    super(...arguments);
                    this.pickerRef = React.createRef();
                    this.focus = () => {
                        if (this.pickerRef.current) {
                            this.pickerRef.current.focus();
                        }
                    };
                    this.blur = () => {
                        if (this.pickerRef.current) {
                            this.pickerRef.current.blur();
                        }
                    };
                    this.getDefaultLocale = () => {
                        const { locale } = this.props;
                        const result = Object.assign(Object.assign({}, enUS), locale);
                        result.lang = Object.assign(Object.assign({}, result.lang), (locale || {}).lang);
                        return result;
                    };
                    this.renderPicker = (locale) => {
                        const { getPrefixCls, direction, getPopupContainer } = this.context;
                        const _a = this.props, { prefixCls: customizePrefixCls, getPopupContainer: customizeGetPopupContainer, className, size: customizeSize, bordered = true, placeholder } = _a, restProps = __rest(_a, ["prefixCls", "getPopupContainer", "className", "size", "bordered", "placeholder"]);
                        const { format, showTime } = this.props;
                        const prefixCls = getPrefixCls('picker', customizePrefixCls);
                        const additionalProps = {
                            showToday: true,
                        };
                        let additionalOverrideProps = {};
                        if (picker) {
                            additionalOverrideProps.picker = picker;
                        }
                        const mergedPicker = picker || this.props.picker;
                        additionalOverrideProps = Object.assign(Object.assign(Object.assign({}, additionalOverrideProps), (showTime ? getTimeProps(Object.assign({ format, picker: mergedPicker }, showTime)) : {})), (mergedPicker === 'time'
                            ? getTimeProps(Object.assign(Object.assign({ format }, this.props), { picker: mergedPicker }))
                            : {}));
                        return (<SizeContext.Consumer>
            {size => {
                            const mergedSize = customizeSize || size;
                            return (<RCPicker ref={this.pickerRef} placeholder={getPlaceholder(mergedPicker, locale, placeholder)} suffixIcon={mergedPicker === 'time' ? <ClockCircleOutlined /> : <CalendarOutlined />} clearIcon={<CloseCircleFilled />} allowClear transitionName="slide-up" {...additionalProps} {...restProps} {...additionalOverrideProps} locale={locale.lang} className={classNames(className, {
                                [`${prefixCls}-${mergedSize}`]: mergedSize,
                                [`${prefixCls}-borderless`]: !bordered,
                            })} prefixCls={prefixCls} getPopupContainer={customizeGetPopupContainer || getPopupContainer} generateConfig={generateConfig} prevIcon={<span className={`${prefixCls}-prev-icon`}/>} nextIcon={<span className={`${prefixCls}-next-icon`}/>} superPrevIcon={<span className={`${prefixCls}-super-prev-icon`}/>} superNextIcon={<span className={`${prefixCls}-super-next-icon`}/>} components={Components} direction={direction}/>);
                        }}
          </SizeContext.Consumer>);
                    };
                }
                render() {
                    return (<LocaleReceiver componentName="DatePicker" defaultLocale={this.getDefaultLocale}>
            {this.renderPicker}
          </LocaleReceiver>);
                }
            }
            Picker.contextType = ConfigContext;
            return Picker;
        })();
        if (displayName) {
            Picker.displayName = displayName;
        }
        return Picker;
    }
    const DatePicker = getPicker();
    const WeekPicker = getPicker('week', 'WeekPicker');
    const MonthPicker = getPicker('month', 'MonthPicker');
    const YearPicker = getPicker('year', 'YearPicker');
    const TimePicker = getPicker('time', 'TimePicker');
    return { DatePicker, WeekPicker, MonthPicker, YearPicker, TimePicker };
}
